import axios from "axios";

axios.defaults.headers.common = {
  "Content-Type": "application/json",
  Accept: "application/json, text/plain, */*"
};

axios.defaults.withCredentials = false;

const localhttp = axios.create({
  baseURL: process.env.VUE_APP_API_BASEURL
});

const trackinghttp = axios.create({
  baseURL: process.env.VUE_APP_API_TRACKINGURL
});

export { localhttp, trackinghttp };

export default localhttp;
